import React from 'react';
import { Form } from 'semantic-ui-react';
import { Label } from './label';
import { FieldError } from './field-error';
import { setupField } from '../utils/form-utils';
import LocationSelector from '../../widgets/location-selector';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function LocationField(props: any) {
  const { handleBlur, handleChange, field, error } = setupField(props);
  return (
    <Form.Field inline>
      <Label>Location</Label>
      <LocationSelector {...field} onChange={handleChange} onBlur={handleBlur} error={error} />
      <FieldError {...props}></FieldError>
    </Form.Field>
  );
}
